module.exports = __webpack_public_path__ + "static/img/simpleui_projector_lx_down.36e42e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/simpleui_projector_lx_down.png
// module id = VstS
// module chunks = 3